import { Navigate } from 'react-router-dom';

import { useDetailedMerchantListQuery } from '~src/pages/merchant/queries';

import { getStoredSiteId } from '../hooks/useSiteId';
import { AppRoute } from '../routes';

export function AppRedirect() {
  const { merchants } = useDetailedMerchantListQuery();
  const storedSiteId = getStoredSiteId();

  /**
   * If we have a stored siteId (saved to storage), we should prioritize that one.
   * We should also ensure that the stored siteId is one of the sites the user has access to.
   */
  if (storedSiteId && merchants.find(m => m.sites.some(s => s.id === storedSiteId))) {
    return <Navigate to={`/${AppRoute.SITE}/${storedSiteId}`} />;
  }

  /**
   * If the user only has one merchant and site there's no point of asking for the merchant,
   * in that case we can assume that they want to use that merchant and/or site.
   */
  if (merchants.length === 1 && merchants[0].sites.length === 1) {
    return <Navigate to={`/${AppRoute.SITE}/${merchants[0].sites[0].id}`} />;
  }

  return <Navigate to={AppRoute.SITE} />;
}
